import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DisplayScaleService {
  private readonly minDpr125 = 1.2;
  private readonly maxDpr125 = 1.35;
  private readonly minCompensatedDpr = 1.45;
  private readonly maxCompensatedDpr = 1.75;
  private readonly compensatedZoom = 0.8;
  private readonly emulatedBreakpoints = [1200, 1400, 1536];
  private initialized = false;

  init(): void {
    if (this.initialized) return;

    this.initialized = true;
    this.apply();

    window.addEventListener('resize', () => this.apply(), { passive: true });
    window.visualViewport?.addEventListener('resize', () => this.apply(), { passive: true });
  }

  private apply(): void {
    const dpr = window.devicePixelRatio || 1;
    const isDpr125 = dpr >= this.minDpr125 && dpr <= this.maxDpr125;
    const shouldCompensate = dpr >= this.minCompensatedDpr && dpr <= this.maxCompensatedDpr;
    const zoom = shouldCompensate ? this.compensatedZoom : 1;
    const effectiveLayoutWidth = window.innerWidth / zoom;
    const root = document.documentElement;

    root.classList.toggle('cck-display-scale-dpr-125', isDpr125);
    root.classList.toggle('cck-display-scale-compensated', shouldCompensate);
    root.style.setProperty('--cck-display-scale-zoom', String(zoom));
    root.style.setProperty('--cck-display-scale-dpr', String(dpr));
    root.style.setProperty('--cck-display-scale-layout-width', String(effectiveLayoutWidth));

    this.emulatedBreakpoints.forEach((breakpoint) => {
      root.classList.toggle(
        `cck-layout-ge-${breakpoint}`,
        shouldCompensate && effectiveLayoutWidth >= breakpoint
      );
    });
  }
}
